import React, { useCallback } from 'react';
import { createFormField } from 'Shared/utils/createFormField';
import RadioInput from 'Shared/components/RadioInput/RadioInput';

type Props = {
  options: Array<{
    value: string | number;
    label: string;
  }>;
  onChange: Function;
  value: string;
  className: string;
  onFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  optionClassName: string;
  error: string;
  touched: boolean;
  errorLabel?: boolean;
};

export function CheckboxGroup({
  value,
  onChange,
  onFocus,
  onBlur,
  options,
  className,
  optionClassName,
  touched,
  error,
  errorLabel = true,
}: Props) {
  const handleChange = useCallback(
    fieldValue => {
      onChange(fieldValue);
      setTimeout(onFocus);
      setTimeout(onBlur);
    },
    [onChange, onBlur, onFocus]
  );
  return (
    <div className={`d-flex flex-column ${className}`}>
      {options.map(option => (
        <RadioInput
          key={option.value}
          label={option.label}
          className={optionClassName}
          value={option.value}
          checked={option.value === value}
          onClick={handleChange}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      ))}
      {touched && error && errorLabel ? <p className="form-input-error text-danger">{error}</p> : null}
    </div>
  );
}

export default createFormField(CheckboxGroup);
